import { useBranchListQuery } from '@common/git/git-hooks';
import { useMemo } from 'react';

export const useBranchData = (projectId: string) => {
  const { isLoading: isProjectBranchLoading, data: ProjectBranchData } = useBranchListQuery({
    projectId
  });

  const projectData = ProjectBranchData?.Project;
  const currentMainBranch = projectData?.mainBranch;
  const workingBranch = projectData?.listBranches?.workingBranch;

  const branches = useMemo(() => {
    if (projectData) {
      const {
        mainBranch,
        listBranches: { checkedOutBranches }
      } = projectData;
      return checkedOutBranches.map((b) => ({
        label: b,
        value: b,
        disabled: mainBranch === b
      }));
    }
    return [];
  }, [projectData]);

  return { isProjectBranchLoading, currentMainBranch, workingBranch, branches };
};
